import { Modal } from 'antd';
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { requestsActions } from '../containers/Requests/requests.actions';
import { actions } from '../actions/housing-stock.actions'
import { actions as mapActions } from '../actions/map-actions'
import { Timeline, Icon, Button, Spin, Result, Badge } from 'antd';
import { HistoryIcon } from '../resource/icons';
import DspxRequest from './request';
import { YMaps, Map, useYMaps, Placemark } from '@pbe/react-yandex-maps';
import { MapContainer, MapConsumer, useMapEvents, LayerGroup, useMapEvent, TileLayer, DivIcon, CircleMarker, Marker, Popup, useMap, Polygon, Polyline, Tooltip as MapTooltip } from 'react-leaflet'
import L from 'leaflet'
import "leaflet-control-geocoder/dist/Control.Geocoder";

function MapSpin({ position, loading }) {

  const POSITION_CLASSES = {
    bottomleft: 'leaflet-bottom leaflet-left',
    bottomright: 'leaflet-bottom leaflet-right',
    topleft: 'leaflet-top leaflet-left',
    topright: 'leaflet-top leaflet-right',
  }

  const control = <Spin size="large"  spinning={loading} tip="Загрузка..." ></Spin>

  const positionClass = (position && POSITION_CLASSES[position]) || POSITION_CLASSES.topleft
  return (
    <div className={positionClass} style={{paddingTop:'30%', paddingLeft:'50%'}}>
      <div>{control}</div>
    </div>
  )
}

function MapMessage({ position, visible, on_click }) {

  const POSITION_CLASSES = {
    bottomleft: 'leaflet-bottom leaflet-left',
    bottomright: 'leaflet-bottom leaflet-right',
    topleft: 'leaflet-top leaflet-left',
    topright: 'leaflet-top leaflet-right', 
  }
  

  const mmessage = useMemo(
    () => (
      <Result      
      style={{backgroundColor: 'white', zIndex: 999999}}
      status="warning"
      title="Адрес не найден"      
      extra={[
        <Button type="primary" key="console" onClick={(e)=>{on_click&&on_click()}}>
          Закрыть
        </Button>,        
      ]}
    >
    </Result>
    ),
    [],)
 
    const positionClass = (position && POSITION_CLASSES[position]) || POSITION_CLASSES.topright
    return (
      <div className={positionClass} style={{paddingLeft: '35%', paddingTop: '20%', display: visible? 'block':'none'}}>
        <div className="leaflet-control leaflet-bar">{mmessage}</div>
      </div>)
}

function MapLocation({pos}) {

  const map = useMap();

  if(!pos) return null;
  
  const {count, streetName, building, corpus, lat, lon} = pos;
  const corp = corpus ? ` к${corpus}` : '';


  const isz = count > 99 ? 30 : count > 9 ? 25 : 21;
  const myIcon = L.divIcon({
    iconSize: isz,
    className: 'res-circle',
    html: '<div class="circle-txt">'+count+'</div>'
  })
  const locIcon = L.icon({
    iconUrl: 'https://dispex.org/img/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12, 40],
    //popupAnchor: [-3, -76],
    shadowUrl: 'https://dispex.org/img/marker-shadow.png',
    //shadowSize: [68, 95],
    shadowAnchor: [12, 40]

  });


  const tt = <MapTooltip >{`${streetName} ${building} ${corp}`}</MapTooltip>;

  map.flyTo(pos, map.getZoom())
  
  return count > 1 ? <LayerGroup>
  <Marker position={[lat,lon]} icon={locIcon} >{tt}</Marker>
  <Marker position={[lat,lon]} icon={myIcon}>{tt}</Marker>
   </LayerGroup> : <Marker position={[lat,lon]}>{tt}</Marker>

}

const MapAddLocations = ({locations}) => {

  const map = useMap();

  if (!locations || locations.length<1) return null;

  if(locations.length>1) {
    let b = { 
      tlat:locations[0].lat, 
      tlon:locations[0].lon, 
      blat:locations[0].lat, 
      blon:locations[0].lon,  
    }

    locations.forEach(e => {
      if(b.tlat > e.lat ) b.tlat = e.lat;
      if(b.tlon > e.lon ) b.tlon = e.lon;
      if(b.blat < e.lat ) b.blat = e.lat;
      if(b.blon < e.lon ) b.blon = e.lon;    
    });

    map.flyToBounds([
      [b.tlat, b.tlon],
      [b.blat, b.blon]]); 
 }

  return locations.map(el => {
        const {count, streetName, building, corpus, lat, lon} = el;
        const corp = corpus ? ` к${corpus}` : '';

        const isz = count > 99 ? 30 : count > 9 ? 25 : 21;
        const myIcon = L.divIcon({
          iconSize: isz,
          className: 'res-circle',
          html: '<div class="circle-txt">'+count+'</div>'
        })
        const locIcon = L.icon({
          iconUrl: 'https://dispex.org/img/marker-icon.png',
          iconSize: [25, 41],
          iconAnchor: [12, 40],
          //popupAnchor: [-3, -76],
          shadowUrl: 'https://dispex.org/img/marker-shadow.png',
          //shadowSize: [68, 95],
          shadowAnchor: [12, 40]

      });
      
        const tt = <MapTooltip >{`${streetName} ${building} ${corp}`}</MapTooltip>;
        
        //return <CircleMarker center={[lat,lon]}>{tt}</CircleMarker>
        return <LayerGroup>
            <Marker position={[lat,lon]} icon={locIcon} >{tt}</Marker>
            <Marker position={[lat,lon]} icon={myIcon}>{tt}</Marker>
             </LayerGroup>
    });
  }	


  const MapPosLocations = ({locations}) => {

    const map = useMap();
  
    if (!locations || locations.length<0) return null;
    
    return locations.map(el => {
          const {name, lat, lon} = el;
  
          //const isz = count > 99 ? 30 : count > 9 ? 25 : 21;
          const locIcon = L.icon({
            iconUrl: 'https://dispex.org/img/pos-marker-icon.png',
            iconSize: [25, 25],
            iconAnchor: [12, 12],
            //popupAnchor: [-3, -76],
            //shadowSize: [68, 95],
            shadowAnchor: [12, 12]
  
        });
        
          const tt = <MapTooltip >{`${name}`}</MapTooltip>;
          
          return <LayerGroup>
              <Marker position={[lat,lon]} icon={locIcon} >{tt}</Marker>
               </LayerGroup>
      });
    }	
  

function RequestMap(props) {    

  //const mapRef = useRef(null);

  const ymaps = useYMaps(['Map']);
  const [visible, setVisible] = useState(props.visible)
  const [yamap, setYamap] = useState(null)
  const [notFound, setNotFound] = useState(false)
  const [mapBounds, setMapBounds] = useState(null)
  const [mapPosition, setMapPosition] = useState(null)
  const [requestsLocation, setRequestsLocation] = useState([])
	const [geoLoading, setGeoLoading] =  useState(false)

  const mapRef = useCallback(node => {
    console.log("ref", node); 
    if (node !== null) {

        if (!ymaps) {
          console.log(ymaps)
          return;
        }
        //setYamap(new ymaps.Map(node, {center: [57.150, 65.55], zoom: 16,}));        
        setYamap(node);        
    }}, [ymaps]);

  const posLocations = [
    {
        name:'Иванов В. А.',
        lat: 57.100464472930554, 
        lon: 65.61137080192567    
    },
    {
      name:'Кузнецов М. С.',
      lat: 57.10193373284152, 
      lon: 65.61284072430489
    },
    {
      name:'Петров Т. К.',
      lat: 57.09965088154941, 
      lon: 65.61414967718578    
    },
  ]

  const hide = (e) => {    
    e.stopPropagation();
    setNotFound(false)
    setRequestsLocation([]);
    props.onHide && props.onHide()
  }

  const getGeoData = async ()=>{
    //setGeoLoading(true);
    const ls = requestsLocation.slice();

    const ll = props.requests.length;
    for(let i=0; i<ll; i++) {
      const e = props.requests[i];
      const idx = ls.findIndex(el=>el.houseId==e.houseId);
      if(idx>-1) {
        ls[idx].count = ls[idx].count + 1;
      } else {
        await mapActions.getGeoData({geoNode: {...e,  city: 'Тюмень'}, 
        completion: (data)=>{
          if(data&&data[0]&&data[0].lat) {
            const {streetName, building, corpus, houseId } = e;
            const geojson = data.dispexStore ? JSON.parse(data[0].geojson) : data[0].geojson;    
            ls.push({...geojson, count:1, houseId, lat:data[0].lat, lon:data[0].lon, streetName, building, corpus})
          }
          else { }
        }});
      }
    };

    if(ls&&ls.length>0) {
      if(ls.length==1) {
        setRequestsLocation(ls);
        setMapBounds(null);
        setMapPosition(ls[0]);
      }
      else {         
        let ll = [ ls[0].lat, ls[0].lon ]
        let ur = [ ls[0].lat, ls[0].lon ]    
        ls.forEach(e => {
          if(ll[0] > e.lat ) ll[0] = e.lat;
          if(ll[1] > e.lon ) ll[1] = e.lon;
          if(ur[0] < e.lat ) ur[0] = e.lat;
          if(ur[1] < e.lon ) ur[1] = e.lon;
        });
    
        setRequestsLocation(ls);
        setMapPosition(null);
        setMapBounds([ll,ur]); 
      }
    } else {
      setMapBounds(null);
      setMapPosition(null) 
      setNotFound(true)
    }

    //setGeoLoading(false);
  }

    useEffect( ()=>{        
        setVisible(props.visible) 

        if(props.visible) {

          getGeoData();

        }
        else {  
        }
    },[props.visible])
    

    return( <div>
      <Modal            
          visible={visible}
          onOk={hide}
          onCancel={hide}
          width={900}              
          centered={true}
          closable={false}
          destroyOnClose={true}
          bodyStyle={{padding:'5px 5px 5px 5px'}}
          //footer={[ <Button key="back" onClick={hide}>Закрыть</Button>,]}
          footer={null}
        >

{/*
      <div ref={mapRef} style={{ width: '100%', height: '650px' }} />
*/}

<MapMessage position="topleft" visible={notFound} on_click={()=>{setNotFound(false)}}/>

<Map  defaultState={{ 
  center: mapPosition?[mapPosition.lat,mapPosition.lon]:[57.150, 65.55], 
  zoom: 17, }} width={'100%'} height={'650px'}

  state={{ 
    bounds: mapBounds,
    center: mapPosition?[mapPosition.lat,mapPosition.lon]:[57.150, 65.55],zoom: 17}}
>
  {requestsLocation.map(p => <Placemark key={`${p.houseId}`} geometry={[p.lat,p.lon]} />)}
  
</Map>
{/*
<MapContainer center={mapPosition?[mapPosition.lat,mapPosition.lon]:[57.150, 65.55]} zoom={17} scrollWheelZoom={true} style={{width:'100%', height:'650px'  }}		
    whenCreated={map=>{ 
      console.log('--- MAP Created') 
      getGeoData();
      }}>
  <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
	  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      <MapSpin position="topleft" loading={geoLoading} />

      <MapLocation pos={mapPosition} />

      <MapPosLocations locations={posLocations} />

      <MapAddLocations locations={requestsLocation} />

      <MapMessage position="topleft" visible={notFound} on_click={()=>{setNotFound(false)}}/>
</MapContainer>
    */}


{/*<DspxRequest request={props.requests && props.requests[0]}/>*/}


</Modal>
    </div>);
}
export default RequestMap